import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConnectionService } from '../../connection.service';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.css']
})
export class TokenComponent implements OnInit {
	toekenRes :any; name;
  SrVoteInfo: any;
  voteTime: number;
  txid: any;
  timeString: string = '';

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute,private spinner: NgxSpinnerService) { 
		this.txid = this.actRoute.snapshot.params['txid']

  }

  ngOnInit() {
    this.getVoteInfo()
    setTimeout(() => {
			this.calculateTimeRemaining()
		}, 2000)
  }

  getVoteInfo() {
		this.spinner.show()
		this.conn.postUrl('vote/voteListByHash', { hash: this.txid }).subscribe((resp: any) => {
			if (resp.success == true) {
				this.spinner.hide()
				this.SrVoteInfo = resp.data
				this.voteTime = new Date(this.SrVoteInfo.created_at).getTime()
			}

		})
	}

  calculateTimeRemaining() {
		const currentTime = new Date().getTime();
		
			const timeDifference = currentTime - this.voteTime;
			if (timeDifference > 0) {
				const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
				this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
				setTimeout(() => {
					this.calculateTimeRemaining();
				}, 1000);
			} else {
				// this.timeString = 'Timer expired!';
			}
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.alert.success('Copied to the clipboard');
	}
}